import React from 'react';
import {Grid} from '@mui/material';
import {Page} from "../../components/page/Page";
import {NotReturnedKeysWidget} from "./not-returned-keys/NotReturnedKeysWidget";
import {ResidentsWithoutKeysWidget} from "./residents-without-keys/ResidentsWithoutKeysWidget";
import {NonResidentsWithKeysWidget} from "./non-residents-with-keys/NonResidentsWithKeysWidget";
import {EmployeesWithMultipleKeysWidget} from "./employees-with-multiple-keys/EmployeesWithMultipleKeysWidget";
import {GhostKeysWidget} from "./ghost-keys/GhostKeysWidget";
import {DesksAssignedToInactiveEmployeesWidget} from "./desks-assigned-to-inactive-employees/DesksAssignedToInactiveEmployeesWidget";
import {DesksAssignedToNonResidentsWidget} from "./desks-assigned-to-non-residents/DesksAssignedToNonResidentsWidget";
import {DeskNeighbourhoodMismatchWidget} from "./desk-neighbourhood-mismatch/DeskNeighbourhoodMismatchWidget";
import {InactiveEmployeesWithKeysWidget} from "./inactive-employees-with-keys/InactiveEmployeesWithKeysWidget";
import {LogProfiler} from "../../components/log-profiler/LogProfiler";
import {LostAndDamagedCardsWidget} from "./lost-and-damaged-cards/LostAndDamagedCardsWidget";
import {AssignedDesksUsedLessThanFlexDesksWidget} from "./assigned-desks-used-less-than-flex-desks/AssignedDesksUsedLessThanFlexDesksWidget";
import {DesksAssignedToLowAttendanceEmployeesWidget} from "./desks-assigned-to-low-attendance-employees/DesksAssignedToLowAttendanceEmployeesWidget";
import {RegularOfficeEmployeesWithoutAssignedDesksWidget} from "./regular-office-employees-without-assigned-desks/RegularOfficeEmployeesWithoutAssignedDesksWidget";
import {AbandonedNeighbourhoodsWidget} from "./abandoned-neighbourhoods/AbandonedNeighbourhoodsWidget";

const widgets = [
    NotReturnedKeysWidget,
    LostAndDamagedCardsWidget,
    EmployeesWithMultipleKeysWidget,
    InactiveEmployeesWithKeysWidget,
    NonResidentsWithKeysWidget,
    ResidentsWithoutKeysWidget,
    GhostKeysWidget,
    DesksAssignedToInactiveEmployeesWidget,
    DesksAssignedToNonResidentsWidget,
    DeskNeighbourhoodMismatchWidget,
    DesksAssignedToLowAttendanceEmployeesWidget,
    RegularOfficeEmployeesWithoutAssignedDesksWidget,
    AssignedDesksUsedLessThanFlexDesksWidget,
    AbandonedNeighbourhoodsWidget,
];

function DashboardPage() {
    return (
        <Page
            header="Dashboard"
            description="Current office problems that may need attention."
        >
            <LogProfiler id="Dashboard">
                <Grid container spacing={3} alignItems="stretch">
                    {widgets.map((Widget, index) => (
                        <Grid key={index} size={{xs: 12, md: 6}} display="flex">
                            <LogProfiler id={Widget.name}>
                                <Widget/>
                            </LogProfiler>
                        </Grid>
                    ))}
                </Grid>
            </LogProfiler>
        </Page>
    );
}

export default DashboardPage;
